import React, { useEffect, useState, useRef } from 'react';
import toast from 'react-hot-toast';

import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
import classes from './ViewAttendance.module.scss';
import { fetchAttendance } from './../../API/API';


const ViewAttendance = () => {
  const [AttendanceData, setAttendanceDate] = useState([]);
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [openDrawer, setOpenDrawer] = useState(false);
  const [days, setDays] = useState([]);
  const date = useRef(null)

  const maxDate = new Date().toISOString().substring(0, 10);

  useEffect(() => {
    const viewAtt = async () => {
      const userID = localStorage.getItem('userID')
      const data = JSON.parse(localStorage.getItem('data'));
      if (userID !== null) {
        const date = new Date();
        const fifteenDaysAgo = new Date();
        fifteenDaysAgo.setDate(fifteenDaysAgo.getDate() - 30);

        const currentDate = date.toISOString().substring(0, 10);
        const newDate = fifteenDaysAgo.toISOString().substring(0, 10);

        try {

          const response = await fetchAttendance(userID, data.empid, data.token, newDate, currentDate);
          setAttendanceDate(response.data);
        } catch (error) {
          toast(error.message, {
            icon: '❗',
            duration: 4500
          });
        }
      }
    }
    viewAtt();
  }, [])

  console.log(days)
  const changeDate = async (event) => {
    event.preventDefault();
    const userID = localStorage.getItem('userID')
    const data = JSON.parse(localStorage.getItem('data'));

    try {
      const response = await fetchAttendance(userID, data.empid, data.token, fromDate, toDate);
      setAttendanceDate(response.data);
      setOpenDrawer(false);
      toast.success(`Attendance From ${fromDate} To ${toDate}`, {
        duration: 4000
      })

    } catch (error) {
      toast(error.message, {
        icon: '❗',
        duration: 4500
      });
    }

  }


  return (
    <>
      <BreadCrumb name="View Attendance" />
      <div className={classes.OpenDrawer}>
        <p>Set Date to View Attendance</p>
        <span className='material-icons icons' onClick={() => { setOpenDrawer(!openDrawer) }}>
          expand_more
        </span>
      </div>
      <div className={classes.ViewAttendance}>
        {openDrawer && <>
          <div className={classes.InputDiv}>
            {/* From Date */}
            <div className={classes.Inputs}>
              <label htmlFor="fromDate">
                <h2>From Date</h2>
              </label>
              <input type="date" name='fromDate' min='2021-01-01' max={toDate} onChange={(event) => { setFromDate(event.target.value) }} />

              {/* To Date */}
              <label htmlFor="toDate">
                <h2>To Date</h2>
              </label>
              <input type="date" name='maxDate' min='2021-01-01' max={maxDate} onChange={(event) => { setToDate(event.target.value) }} />
            </div>

            <button onClick={changeDate}>
              View Attendance
            </button>
          </div>
        </>}


        <div className={classes.AttendanceDiv}>
          <div className={classes.TableDiv}>
            <table cellSpacing={0}>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Check In Time</th>
                  <th>Check Out time</th>
                </tr>
              </thead>
              <tbody>
                {AttendanceData.map((item, index) => {
                  return (
                    <tr key={index}>
                      {item.flag === "ABS" ?
                        <>
                          <td>
                            {new Date(item.dt).toString().substring(0, 3)}
                            <br />
                            {item.dt.substring(5).split('-').reverse().join('/')}
                                    /{item.dt.substring(2, 4)}
                             </td>
                          <td style={{ color: "#EA6A47" }}>Absent</td>
                          <td style={{ color: "#EA6A47" }}>Absent</td>
                        </>
                        : (item.flag === 'GH' ?
                          <>
                            <td>
                              {new Date(item.dt).toString().substring(0, 3)}
                              <br />
                              {item.dt.substring(5).split('-').reverse().join('/')}
                                    /{item.dt.substring(2, 4)}
                            </td>
                            <td style={{ color: "#1C4E80" }} >{item.holiday}</td>
                            <td style={{ color: "#1C4E80" }} >{item.holiday}</td>
                          </>
                          : (item.flag === 'LV' ? <>
                            <td>
                              {new Date(item.dt).toString().substring(0, 3)}
                              <br />
                              {item.dt.substring(5).split('-').reverse().join('/')}
                                    /{item.dt.substring(2, 4)}
                            </td>
                            <td style={{ color: "#EA6A47" }} >{item.leave}</td>
                            <td style={{ color: "#EA6A47" }} >{item.leave}</td>
                          </> : (item.flag === 'WO' ?
                            <>
                              <td>
                                {new Date(item.dt).toString().substring(0, 3)}
                                <br />
                                {item.dt.substring(5).split('-').reverse().join('/')}
                                    /{item.dt.substring(2, 4)}
                              </td>
                              <td style={{ color: "#1C4E80" }} >Weekend Off</td>
                              <td style={{ color: "#1C4E80" }} >Weekend Off</td>
                            </> : (
                              <>
                                < td >
                                  {new Date(item.dt).toString().substring(0, 3)}
                                  <br />
                                  <div>{item.dt.substring(5).split('-').reverse().join('/')}
                                    /{item.dt.substring(2, 4)}
                                  </div>
                                </td >
                                <td >
                                  {item.in_time === null || item.in_from === null ?
                                    <span style={{ color: '#EA6A47' }}>Not Checked In</span>
                                    : <div>
                                      {`${item.in_from.replace(/_/g, " ").substring(0, 11)}...`}
                                      <br />
                                      {item.in_time}
                                    </div>}

                                </td>
                                <td>
                                  {item.out_time === null ?
                                    <span style={{ color: '#EA6A47' }}>Not Checked Out</span>
                                    : <div>
                                      {`${item.out_from.replace(/_/g, " ").substring(0, 11)}...`}
                                      <br />
                                      {item.out_time}
                                    </div>}
                                </td>
                              </>

                            )
                          )
                          )
                        )
                      }
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewAttendance;


/////////////////////////Testing code::::


